import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import "mdb-ui-kit/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Input, Ripple, initMDB } from "mdb-ui-kit";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useMediaQuery, useTheme } from "@mui/material";
import FooterManual from "./footerManual";
import Notes from "./header";

initMDB({ Input, Ripple, initMDB });

// Define the new color palette for easy use and consistency
const PRIMARY_RED = "#DC2626";
const LIGHT_RED = "#FEE2E2";
const DARK_RED = "#990000";
const RED_GRADIENT = `linear-gradient(135deg, ${DARK_RED} 0%, ${PRIMARY_RED} 100%)`;
const HEADING_BLACK = "#000000";
const CARD_BACKGROUND_GRAY = "#F5F5F5";
const GRAY_TEXT = "#4B5563";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
        backgroundColor: "#1A2027",
    }),
}));

const TermsandCondition = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <Box
            className="container-main-AllSeeModels"
            sx={{
                position: "relative",
                width: "100%",
                minHeight: "100vh",
                backgroundColor: "#FFFFFF",
            }}
        >
            <Box sx={{ marginBottom: "0%" }}><Notes /></Box>

            {/* Banner Section */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: isMobile ? "25vh" : isTablet ? "35vh" : "50vh",
                    backgroundColor: "black",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: "hidden",
                }}
            >
                <Box
                    component="img"
                    src="/image/AllSeeModelsBackgroungCar.png"
                    alt="terms and conditions background"
                    sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: 0.35,
                    }}
                />

                <Typography
                    sx={{
                        position: "relative",
                        color: "white",
                        fontWeight: "900",
                        textTransform: "uppercase",
                        letterSpacing: isMobile ? "1px" : isTablet ? "2px" : "4px",
                        fontSize: isMobile ? "24px" : isTablet ? "42px" : "60px",
                        zIndex: 2,
                        textShadow: "0 0 10px rgba(0,0,0,0.8)",
                        textAlign: "center",
                        lineHeight: 1.1,
                        px: "20px",
                    }}
                >
                    Terms & Conditions
                </Typography>
            </Box>

            {/* Main Content Container */}
            <Box
                sx={{
                    width: isMobile ? "95%" : isTablet ? "92%" : "85%",
                    backgroundColor: "#FFFFFF",
                    margin: "0 auto",
                    marginTop: isMobile ? "-50px" : isTablet ? "-60px" : "-80px",
                    borderRadius: isMobile ? "12px" : isTablet ? "16px" : "20px",
                    padding: isMobile ? "20px 16px" : isTablet ? "32px 24px" : "40px 30px",
                    boxShadow: "0 15px 50px rgba(0, 0, 0, 0.12)",
                    zIndex: 10,
                    position: "relative",
                }}
            >
                {/* Introduction Section */}
                <Box sx={{ textAlign: "center", marginBottom: isMobile ? "35px" : isTablet ? "45px" : "60px" }}>
                    <Typography
                        sx={{
                            fontWeight: "800",
                            color: DARK_RED,
                            marginBottom: isMobile ? "10px" : "12px",
                            textTransform: "uppercase",
                            fontSize: isMobile ? "18px" : isTablet ? "24px" : "32px",
                            lineHeight: 1.3,
                        }}
                    >
                        Please Read Our Terms Carefully
                    </Typography>
                    <Typography
                        sx={{
                            color: GRAY_TEXT,
                            fontSize: isMobile ? "13px" : isTablet ? "14px" : "16px",
                            maxWidth: "900px",
                            margin: "0 auto",
                            lineHeight: "1.7",
                            px: isMobile ? "12px" : "0",
                        }}
                    >
                        Welcome to Amar Enterprises Co Ltd. These <b>Terms & Conditions</b> govern your access and use of our platform, products, and services. By accessing or using our site, you agree to be bound by these terms. Please review them carefully before using our platform.
                    </Typography>
                </Box>

                {/* Effective Date Section */}
                <Box
                    sx={{
                        backgroundColor: LIGHT_RED,
                        border: `2px solid ${PRIMARY_RED}`,
                        borderRadius: isMobile ? "8px" : "12px",
                        padding: isMobile ? "15px" : isTablet ? "18px" : "20px",
                        marginBottom: isMobile ? "30px" : isTablet ? "40px" : "50px",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: "700",
                            color: PRIMARY_RED,
                            fontSize: isMobile ? "14px" : "16px",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: "8px",
                        }}
                    >
                        <i className="fas fa-calendar-alt" style={{ fontSize: isMobile ? "16px" : "18px" }}></i>
                        Effective Date: 03-11-2025
                    </Typography>
                </Box>

                {/* Section 1: Acceptance and Amendments */}
                <Box
                    sx={{
                        borderLeft: `6px solid ${PRIMARY_RED}`,
                        padding: isMobile ? "16px" : isTablet ? "20px" : "2rem",
                        marginBottom: isMobile ? "20px" : isTablet ? "25px" : "2.5rem",
                        backgroundColor: CARD_BACKGROUND_GRAY,
                        borderRadius: "0 12px 12px 0",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 6px 20px rgba(220, 38, 38, 0.15)`,
                            transform: "translateX(5px)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: isMobile ? "12px" : "1.5rem",
                            gap: isMobile ? "10px" : "15px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            sx={{
                                width: isMobile ? "40px" : "50px",
                                height: isMobile ? "40px" : "50px",
                                background: RED_GRADIENT,
                                color: "#FFFFFF",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: "bold",
                                boxShadow: `0 4px 8px rgba(220, 38, 38, 0.3)`,
                                flexShrink: 0,
                            }}
                        >
                            1
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: "800",
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "22px",
                                color: HEADING_BLACK,
                            }}
                        >
                            Acceptance and Amendments to the Agreement
                        </Typography>
                    </Box>
                    <Box sx={{ pl: { xs: 0, md: "65px" } }}>
                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                                marginBottom: "1rem",
                            }}
                        >
                            <strong>Binding Acceptance:</strong> By accessing or using the Site, you hereby agree to accept the TOU set forth in this Agreement as a User. You shall be bound by the TOU of this Agreement with respect to your access or use of this Site and any further upgrade, modification, addition, or change to this Site.
                        </Typography>
                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                                marginBottom: "1rem",
                            }}
                        >
                            <strong>Right to Update:</strong> AMAR ENTERPRISES CO., LTD. reserves the right to update the Terms of Use (TOU) at any time without notice to you. It is your responsibility to review these terms periodically for any changes.
                        </Typography>
                        <Box
                            sx={{
                                backgroundColor: LIGHT_RED,
                                padding: isMobile ? "12px" : "1rem",
                                borderRadius: "8px",
                                border: `2px dashed ${PRIMARY_RED}`,
                                marginTop: "1rem",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "600",
                                    fontSize: isMobile ? "12px" : "14px",
                                    textAlign: "left",
                                    fontStyle: "italic",
                                }}
                            >
                                If you do not accept all of the TOU of this Agreement, please do not use this Site.
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Section 2: General Use, Account, and Conduct */}
                <Box
                    sx={{
                        borderLeft: `6px solid ${PRIMARY_RED}`,
                        padding: isMobile ? "16px" : isTablet ? "20px" : "2rem",
                        marginBottom: isMobile ? "20px" : isTablet ? "25px" : "2.5rem",
                        backgroundColor: CARD_BACKGROUND_GRAY,
                        borderRadius: "0 12px 12px 0",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 6px 20px rgba(220, 38, 38, 0.15)`,
                            transform: "translateX(5px)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: isMobile ? "12px" : "1.5rem",
                            gap: isMobile ? "10px" : "15px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            sx={{
                                width: isMobile ? "40px" : "50px",
                                height: isMobile ? "40px" : "50px",
                                background: RED_GRADIENT,
                                color: "#FFFFFF",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: "bold",
                                boxShadow: `0 4px 8px rgba(220, 38, 38, 0.3)`,
                                flexShrink: 0,
                            }}
                        >
                            2
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: "800",
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "22px",
                                color: HEADING_BLACK,
                            }}
                        >
                            General Use, Account, and Conduct
                        </Typography>
                    </Box>
                    <Box sx={{ pl: { xs: 0, md: "65px" } }}>
                        <Box sx={{ marginBottom: "1.5rem" }}>
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "700",
                                    fontSize: isMobile ? "14px" : "16px",
                                    marginBottom: "0.5rem",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: PRIMARY_RED,
                                        borderRadius: "50%",
                                    }}
                                />
                                Prohibited Access
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000000",
                                    lineHeight: "1.7",
                                    fontSize: isMobile ? "13px" : "15px",
                                    textAlign: "left",
                                }}
                            >
                                No User shall attempt to gain unauthorized access to any Services, other accounts, computer systems or networks connected to any AMAR ENTERPRISES CO., LTD. server or to any of the Services, through hacking, password mining or any other means.
                            </Typography>
                        </Box>

                        <Box sx={{ marginBottom: "1.5rem" }}>
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "700",
                                    fontSize: isMobile ? "14px" : "16px",
                                    marginBottom: "0.5rem",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: PRIMARY_RED,
                                        borderRadius: "50%",
                                    }}
                                />
                                Content Restrictions
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000000",
                                    lineHeight: "1.7",
                                    fontSize: isMobile ? "13px" : "15px",
                                    textAlign: "left",
                                }}
                            >
                                You may not copy, reproduce, recompile, decompile, disassemble, reverse-engineer, distribute, publish, display, perform, modify, upload to create derivative works from, transmit, communicate or in any other way exploit any part of the information or material obtained through the Website.
                            </Typography>
                        </Box>

                        <Box sx={{ marginBottom: "1.5rem" }}>
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "700",
                                    fontSize: isMobile ? "14px" : "16px",
                                    marginBottom: "0.5rem",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "8px",
                                        height: "8px",
                                        backgroundColor: PRIMARY_RED,
                                        borderRadius: "50%",
                                    }}
                                />
                                Termination Rights
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000000",
                                    lineHeight: "1.7",
                                    fontSize: isMobile ? "13px" : "15px",
                                    textAlign: "left",
                                }}
                            >
                                AMAR ENTERPRISES CO., LTD. reserves the right to terminate your access to any or all of the Communication Services at any time, without notice, for any reason whatsoever, including if provided information is false.
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Section 3: Warranties, Disclaimers, and Limitation of Liability */}
                <Box
                    sx={{
                        borderLeft: `6px solid ${PRIMARY_RED}`,
                        padding: isMobile ? "16px" : isTablet ? "20px" : "2rem",
                        marginBottom: isMobile ? "20px" : isTablet ? "25px" : "2.5rem",
                        backgroundColor: CARD_BACKGROUND_GRAY,
                        borderRadius: "0 12px 12px 0",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 6px 20px rgba(220, 38, 38, 0.15)`,
                            transform: "translateX(5px)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: isMobile ? "12px" : "1.5rem",
                            gap: isMobile ? "10px" : "15px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            sx={{
                                width: isMobile ? "40px" : "50px",
                                height: isMobile ? "40px" : "50px",
                                background: RED_GRADIENT,
                                color: "#FFFFFF",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: "bold",
                                boxShadow: `0 4px 8px rgba(220, 38, 38, 0.3)`,
                                flexShrink: 0,
                            }}
                        >
                            3
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: "800",
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "22px",
                                color: HEADING_BLACK,
                            }}
                        >
                            Warranties, Disclaimers, and Liability
                        </Typography>
                    </Box>
                    <Box sx={{ pl: { xs: 0, md: "65px" } }}>
                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                                marginBottom: "1rem",
                            }}
                        >
                            <strong>Basis of Service:</strong> The features and services on the AMAR ENTERPRISES CO., LTD. site are provided on the "as is" and "as available" basis, and we hereby expressly disclaim any and all warranty except warranty expressly stated herein.
                        </Typography>

                        <Box
                            sx={{
                                backgroundColor: LIGHT_RED,
                                padding: isMobile ? "12px" : "1.5rem",
                                borderRadius: "10px",
                                margin: "1.5rem 0",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "700",
                                    fontSize: isMobile ? "14px" : "16px",
                                    textAlign: "left",
                                    marginBottom: "0.5rem",
                                }}
                            >
                                ⚠️ Important Disclaimer
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000000",
                                    fontSize: isMobile ? "13px" : "14px",
                                    textAlign: "left",
                                    opacity: 0.9,
                                }}
                            >
                                AMAR ENTERPRISES CO., LTD. makes no representations or warranty about the validity, accuracy, correctness, reliability, quality, stability of the information, products and services provided.
                            </Typography>
                        </Box>

                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                                marginBottom: "1rem",
                            }}
                        >
                            <strong>No Refund Liability:</strong> Under no circumstances AMAR ENTERPRISES CO., LTD. is not liable for any refund against any purchase made except warranty expressly stated herein.
                        </Typography>

                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                            }}
                        >
                            <strong>Force Majeure:</strong> Under no circumstances shall AMAR ENTERPRISES CO., LTD. be held liable for a delay or failure resulting directly or indirectly from acts of nature, forces or causes beyond its reasonable control.
                        </Typography>
                    </Box>
                </Box>

                {/* Section 4: Product Sales and Export Terms */}
                <Box
                    sx={{
                        borderLeft: `6px solid ${PRIMARY_RED}`,
                        padding: isMobile ? "16px" : isTablet ? "20px" : "2rem",
                        marginBottom: isMobile ? "20px" : isTablet ? "25px" : "2.5rem",
                        backgroundColor: CARD_BACKGROUND_GRAY,
                        borderRadius: "0 12px 12px 0",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 6px 20px rgba(220, 38, 38, 0.15)`,
                            transform: "translateX(5px)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: isMobile ? "12px" : "1.5rem",
                            gap: isMobile ? "10px" : "15px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            sx={{
                                width: isMobile ? "40px" : "50px",
                                height: isMobile ? "40px" : "50px",
                                background: RED_GRADIENT,
                                color: "#FFFFFF",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: "bold",
                                boxShadow: `0 4px 8px rgba(220, 38, 38, 0.3)`,
                                flexShrink: 0,
                            }}
                        >
                            4
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: "800",
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "22px",
                                color: HEADING_BLACK,
                            }}
                        >
                            Product Sales and Export Terms
                        </Typography>
                    </Box>
                    <Box sx={{ pl: { xs: 0, md: "65px" } }}>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", md: "row" },
                                gap: isMobile ? "12px" : "1.5rem",
                                marginBottom: "2rem",
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: LIGHT_RED,
                                    padding: isMobile ? "12px" : "1.5rem",
                                    borderRadius: "10px",
                                    border: `2px solid ${PRIMARY_RED}`,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: PRIMARY_RED,
                                        fontWeight: "700",
                                        fontSize: isMobile ? "14px" : "16px",
                                        marginBottom: "0.5rem",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    🚗 AS-IS, WHERE-IS Condition
                                </Typography>
                                <Typography
                                    sx={{
                                        color: "#000000",
                                        lineHeight: "1.6",
                                        fontSize: isMobile ? "13px" : "14px",
                                        textAlign: "left",
                                    }}
                                >
                                    All vehicles and parts are sold on an "AS-IS, WHERE-IS" basis unless an explicit, separate written warranty is provided.
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: LIGHT_RED,
                                    padding: isMobile ? "12px" : "1.5rem",
                                    borderRadius: "10px",
                                    border: `2px solid ${PRIMARY_RED}`,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: PRIMARY_RED,
                                        fontWeight: "700",
                                        fontSize: isMobile ? "14px" : "16px",
                                        marginBottom: "0.5rem",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    📦 Risk Transfer
                                </Typography>
                                <Typography
                                    sx={{
                                        color: "#000000",
                                        lineHeight: "1.6",
                                        fontSize: isMobile ? "13px" : "14px",
                                        textAlign: "left",
                                    }}
                                >
                                    Risk of loss transfers to Customer upon loading onto vessel at port of export (FOB/CFR terms as per Pro-forma Invoice).
                                </Typography>
                            </Box>
                        </Box>

                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                                marginBottom: "1rem",
                            }}
                        >
                            <strong>Customer Responsibility:</strong> Customers are solely responsible for all import duties, taxes, customs clearance, licenses, fines, permits, and compliance with destination country regulations.
                        </Typography>

                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                            }}
                        >
                            <strong>Documentation:</strong> Original shipping documents will only be released after full and cleared payment is received.
                        </Typography>
                    </Box>
                </Box>

                {/* Section 5: Data and Disclosure */}
                <Box
                    sx={{
                        borderLeft: `6px solid ${PRIMARY_RED}`,
                        padding: isMobile ? "16px" : isTablet ? "20px" : "2rem",
                        marginBottom: isMobile ? "20px" : isTablet ? "25px" : "2.5rem",
                        backgroundColor: CARD_BACKGROUND_GRAY,
                        borderRadius: "0 12px 12px 0",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 6px 20px rgba(220, 38, 38, 0.15)`,
                            transform: "translateX(5px)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: isMobile ? "12px" : "1.5rem",
                            gap: isMobile ? "10px" : "15px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            sx={{
                                width: isMobile ? "40px" : "50px",
                                height: isMobile ? "40px" : "50px",
                                background: RED_GRADIENT,
                                color: "#FFFFFF",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: "bold",
                                boxShadow: `0 4px 8px rgba(220, 38, 38, 0.3)`,
                                flexShrink: 0,
                            }}
                        >
                            5
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: "800",
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "22px",
                                color: HEADING_BLACK,
                            }}
                        >
                            Data Provided by User and Disclosure
                        </Typography>
                    </Box>
                    <Box sx={{ pl: { xs: 0, md: "65px" } }}>
                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                                marginBottom: "1rem",
                            }}
                        >
                            <strong>User Data Rights:</strong> When participating in any service you may provide us with information about yourself and/or products and services listed. You grant us exclusive rights in all of this information, and all information derived or generated from it.
                        </Typography>

                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                            }}
                        >
                            <strong>Governmental Disclosure:</strong> AMAR ENTERPRISES CO., LTD. reserves the right at all times to disclose any information as necessary to satisfy any applicable law, regulation, legal process or governmental request.
                        </Typography>
                    </Box>
                </Box>

                {/* Section 6: Governing Law and Jurisdiction */}
                <Box
                    sx={{
                        borderLeft: `6px solid ${PRIMARY_RED}`,
                        padding: isMobile ? "16px" : isTablet ? "20px" : "2rem",
                        marginBottom: isMobile ? "20px" : isTablet ? "25px" : "2.5rem",
                        backgroundColor: CARD_BACKGROUND_GRAY,
                        borderRadius: "0 12px 12px 0",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        '&:hover': {
                            boxShadow: `0 6px 20px rgba(220, 38, 38, 0.15)`,
                            transform: "translateX(5px)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: isMobile ? "12px" : "1.5rem",
                            gap: isMobile ? "10px" : "15px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box
                            sx={{
                                width: isMobile ? "40px" : "50px",
                                height: isMobile ? "40px" : "50px",
                                background: RED_GRADIENT,
                                color: "#FFFFFF",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: "bold",
                                boxShadow: `0 4px 8px rgba(220, 38, 38, 0.3)`,
                                flexShrink: 0,
                            }}
                        >
                            6
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: "800",
                                fontSize: isMobile ? "16px" : isTablet ? "18px" : "22px",
                                color: HEADING_BLACK,
                            }}
                        >
                            Governing Law and Jurisdiction
                        </Typography>
                    </Box>
                    <Box sx={{ pl: { xs: 0, md: "65px" } }}>
                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                                marginBottom: "1rem",
                            }}
                        >
                            <strong>Governing Law:</strong> This Agreement shall be governed by the laws of the Japan Jurisdiction only without regard to its conflict of law provisions.
                        </Typography>

                        <Typography
                            sx={{
                                color: "#000000",
                                lineHeight: "1.7",
                                fontSize: isMobile ? "13px" : "15px",
                                textAlign: "left",
                            }}
                        >
                            <strong>Reserved Rights:</strong> Any rights not expressly granted herein are reserved.
                        </Typography>
                    </Box>
                </Box>

                {/* Company Information Footer */}
                <Box
                    sx={{
                        backgroundColor: LIGHT_RED,
                        padding: isMobile ? "16px" : isTablet ? "20px" : "2rem",
                        borderRadius: "8px",
                        border: "2px dashed #DC2626",
                        marginTop: isMobile ? "20px" : "2rem",
                    }}
                >
                    <Typography
                        sx={{
                            color: PRIMARY_RED,
                            fontWeight: "700",
                            fontSize: isMobile ? "16px" : "18px",
                            marginBottom: isMobile ? "16px" : "1rem",
                            textAlign: "center",
                        }}
                    >
                        📋 Key Company and Legal Information
                    </Typography>

                    <Box
                        sx={{
                            // display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            justifyContent: "center",
                            gap: isMobile ? "15px" : "2rem",
                            // marginBottom: "1.5rem",
                            textAlign: { xs: "center", md: "center" },
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "600",
                                    fontSize: isMobile ? "13px" : "14px",
                                    marginBottom: "0.3rem",
                                }}
                            >
                                Company Name
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000000",
                                    fontSize: isMobile ? "13px" : "14px",
                                    marginBottom: "0.5rem",
                                }}
                            >
                                Amar Enterprises Co Ltd
                            </Typography>
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "600",
                                    fontSize: isMobile ? "13px" : "14px",
                                    marginBottom: "0.3rem",
                                    textAlign: { xs: "center", md: "center" },
                                }}
                            >
                                Business License
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000000",
                                    fontSize: isMobile ? "13px" : "14px",
                                    marginBottom: "0.5rem",
                                }}
                            >
                                Saitama Prefectural Public Safety Commission No. 431260012433, Qualification Registration Number: T7-0300-0202-3122
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                textAlign: { xs: "center", md: "center" },
                            }}
                        >
                            <Typography
                                sx={{
                                    color: PRIMARY_RED,
                                    fontWeight: "600",
                                    fontSize: isMobile ? "13px" : "14px",
                                    marginBottom: "0.3rem",
                                }}
                            >
                                Contact for Sales/Warranty
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000000",
                                    fontSize: isMobile ? "13px" : "14px",
                                    marginBottom: "0.5rem",
                                }}
                            >
                                Mobile: +81-48-793-3911 / Email: sales@amar.co.jp
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Space Filler for Footer Alignment */}
            <Box sx={{ height: isMobile ? "10px" : isTablet ? "10px" : "50px" }} />

            {/* Footer */}
            <FooterManual />
        </Box>
    );
};

export default TermsandCondition;